module.exports = __webpack_public_path__ + "static/krasty-section2-dd386b684154cfbc25c6171b40d01863.svg";